"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.4;
  return <section id="hero" ref={containerRef} className="relative h-screen w-full overflow-hidden bg-secondary-dark">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/mexican_restaurant_beach_sunset.png)] transition-transform duration-100 ease-out" style={{
      transform: `translateY(${parallaxOffset}px) scale(1.1)`
    }}>
        {}
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary-dark/40 via-transparent to-secondary-dark/60" />
      </div>

      {}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-6 text-center lg:px-8">
        <div className={`max-w-4xl transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {}
          <div className="mx-auto mb-6 h-px w-24 bg-accent" />
          
          <h1 className="font-display text-5xl font-bold tracking-tight text-foreground-dark sm:text-6xl md:text-7xl lg:text-8xl drop-shadow-strong">
            Marea Mezcal
          </h1>
          
          <p className="mt-6 font-display text-xl font-medium text-foreground-dark/90 sm:text-2xl md:text-3xl italic drop-shadow-medium">
            Cocina Mexicana Contemporánea en el corazón del Caribe
          </p>

          <p className="mx-auto mt-8 max-w-2xl font-sans text-base text-foreground-dark/80 sm:text-lg md:text-xl">Una fusión de sabores tradicionales y presentación moderna en un entorno tropical-lujoso</p>
        </div>

        {}
        <div className={`mt-12 flex flex-col items-center gap-4 sm:flex-row sm:gap-6 transition-all duration-[var(--duration-slow)] delay-300 ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Link to="#reservations">
            <Button size="lg" className="btn-primary min-w-[200px] text-lg px-10 py-7">
              Reservar Mesa
            </Button>
          </Link>
          
          <Link to="#menu">
            <Button variant="outline" size="lg" className="min-w-[200px] border-white/40 bg-white/10 text-lg text-white backdrop-blur-md hover:bg-white/20 hover:border-white px-10 py-7 transition-all duration-300">
              Ver Menú
            </Button>
          </Link>
        </div>

        {}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce opacity-60">
          <div className="h-10 w-6 rounded-full border-2 border-accent/50 flex justify-center p-1">
            <div className="h-2 w-1 rounded-full bg-accent" />
          </div>
        </div>
      </div>
    </section>;
}